import * as yup from 'yup';

// We can't add this directly to a schema via yup.addMethod() because typescript typing does not seem to work for yup.mixed()
export function fileMaxSize(maxMB: number, message: string) {
    return yup
        .mixed()
        .test('max-size', message, (fileList?: FileList | any) => {
            if (!fileList || fileList?.length < 1) {
                return true;
            }
            const validateFile = fileList.item(0)!;
            return validateFile.size <= maxMB * 1024 * 1024;
        });
}

export * from 'yup';
